import inventoryModule from '../inventoryModule';
import { Endpoints } from 'Roblox';

const inventoryConstants = {
    urls: {
        getUserInventory: Endpoints.getAbsoluteUrl("/users/inventory/list-json")
    }
};

inventoryModule.constant("inventoryConstants", inventoryConstants);
export default inventoryConstants;